import { useState } from 'react';
import { Button, Input } from '@nazka/nazka.mapframe.components';
import { faEye, faEyeSlash } from '@fortawesome/pro-regular-svg-icons';

import './password-input.css';

function PasswordInput({
  className,
  value,
  onInputChange,
  onSelect,
  placeholder,
}) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="password-input">
      <Input
        className={`password-input__input${className ? ` ${className}` : ''}`}
        type={showPassword ? 'text' : 'password'}
        value={value}
        onInputChange={v => onInputChange(v?.target?.value)}
        rootElProps={{
          onSelect: () => {
            if (onSelect) {
              onSelect();
            }
          },
          placeholder: placeholder || '',
        }}
      />
      <Button
        className={`password-input__eye${className ? ` ${className}__eye` : ''}`}
        icon={showPassword ? faEye : faEyeSlash}
        onClick={() => setShowPassword(!showPassword)}
        layout="ghost"
        hover={false}
        color="black"
        iconProps={{
          className: 'password-input__eye__icon',
          size: '20px',
        }}
      />
    </div>
  );
}

export default PasswordInput;
